import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderFranklinAdvent from "../../../../src/content/franklin-graham-advent/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderFranklinAdvent,
  React
};